// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videotest {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.videotest > *:last-child {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/Videotest/Videotest.scss"],"names":[],"mappings":"AAAA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AACJ;AACI;EACI,gBAAA;AACR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
